/**
 * @description Validate if an element can be redeem.
 */
export var canRedeemElement = function canRedeemElement(totalCrehanaCoinsAvailable, elementCoins) {
  return totalCrehanaCoinsAvailable > 0 && elementCoins <= totalCrehanaCoinsAvailable;
};